import React from 'react';
import useStyles from 'hooks/useStyles';

import styles from './SnapaskLoader.scss';

export default function SnapaskLoader() {
  useStyles(styles);

  return (
    <div className={styles.root}>
      <span className={styles.bounce1} />
      <span className={styles.bounce2} />
      <span className={styles.bounce3} />
    </div>
  );
}
